import { ResolveFn, Router, UrlTree } from "@angular/router";
import { UserApi } from "../api/user.api";
import { inject } from "@angular/core";
import { catchError, map, of, take } from "rxjs";

export const profileResolver: ResolveFn<boolean | UrlTree> = () => {
  const userApi = inject(UserApi);
  const router = inject(Router);

  if (userApi.user) {
    return of(true);
  }

  return userApi.getAdminProfile().pipe(
    take(1),
    map((user) => {
      userApi.user = user;
      return true;
    }),
    catchError(() => of(router.createUrlTree(['/order-management'])))
  );
};